import { Chip, Switch, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { putUpdateObjectApi } from 'api/general';
import { getUserFullName, isEditable, isRoleCheckList } from 'app/utils/appHelpers';
import { MEETING_USER } from 'app/utils/constants/customConstant';
import { updateMeetingAfterUserOperation } from 'app/utils/meetingReduxHelpers';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function UserListTable({ userList }) {
  const dispatch = useDispatch();
  const [localUserList, setLocalUserList] = useState(userList);
  const authUser = useSelector(state => state.auth.authUser);
  const userRoles = authUser.userRoles;
  const pageType = useSelector((state) => state.meeting.pageType);
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const theme = useTheme();

  useEffect(() => {
    setLocalUserList(userList);
  }, [userList]);

  const { baseFontSize, lineHeight, iconFontSize, chipFontSize } = useTemplateFontSettings();

  const handleAttendanceChange = async (userItem, newStatus) => {
    try {
      let updatedUser = { ...userItem, attendanceStatus: newStatus };
      const { user } = updatedUser;
      delete updatedUser.user;
      const result = await putUpdateObjectApi(MEETING_USER, updatedUser);
      if (result.status) {
        updatedUser.user = user;
        setLocalUserList((prevList) =>
          prevList.map((u) => (u.id === userItem.id ? updatedUser : u))
        );

        await updateMeetingAfterUserOperation(
          currentMeeting,
          authUser,
          dispatch
        );

      }
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  return (
    <Table
      size="small"
      sx={{
        '& .MuiTableCell-root, & p': {
          fontSize: baseFontSize,
          lineHeight: lineHeight,
        },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Unvan</TableCell>
          <TableCell>Atama</TableCell>
          <TableCell>Adı</TableCell>
          <TableCell>Katılma Durumu</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {localUserList.length > 0 ? (
          localUserList.map((user) => (
            <TableRow key={user.id}>
              <TableCell>{user.memberRole}</TableCell>
              <TableCell>{user.acting}</TableCell>
              <TableCell>{getUserFullName(user.user)}</TableCell>
              <TableCell>
                {(isEditable(pageType) === true && isRoleCheckList(userRoles, [1, 370, 373, 372, 369])) ? (
                  <Tooltip title={user.attendanceStatus === 1 ? 'katıldı' : 'katılmadı'}>
                    <Switch
                      size='small'
                      checked={user.attendanceStatus === 1}
                      onChange={(e) =>
                        handleAttendanceChange(user, e.target.checked ? 1 : 0)
                      }
                      color="primary"
                      sx={{ fontSize: iconFontSize }}
                    />
                  </Tooltip>
                ) : user.attendanceStatus === 1 ? (
                  <Chip
                    sx={{
                      height: chipFontSize,
                    }}
                    size='small' label="Katıldı" color="success" />
                ) : (
                  <Chip
                    sx={{
                      height: chipFontSize,
                    }}
                    size='small' label="Katılmadı" color="error" />
                )}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={4} align="center" style={{ fontSize: baseFontSize }}>
              Kayıt Bulunamadı
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell colSpan={4} align="center">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                margin: 5,
                width: "100%",
              }}
            >
              <p style={{ color: theme.palette.success.main, margin: 0, fontSize: baseFontSize }}>
                {"Katılan: " +
                  localUserList.filter((user) => user.attendanceStatus === 1)
                    .length}
              </p>
              <p style={{ color: theme.palette.error.main, margin: 0, fontSize: baseFontSize }}>
                {"Katılmayan: " +
                  localUserList.filter((user) => user.attendanceStatus !== 1)
                    .length}
              </p>
            </div>
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  );
}

export default UserListTable;





